import React, { useEffect } from "react";
import AccountSettingComponent from "../../components/AccountSetting";
import Sidebar from "../../components/Sidebar";
import * as modalActions from "../../redux/actions/modalActions";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "redux-i18n";
import * as profileActions from "../../redux/actions/profileAction";
import * as commonActions from "../../redux/actions/commonAction";
import PropTypes from "prop-types";

const AccountSetting = (props, context) => {
  const dispatch = useDispatch();
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);

  const modalAction = bindActionCreators(modalActions, dispatch);
  let profileAction = bindActionCreators(profileActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);

  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div
        className={
          commonReducer.isSideMenuOpen ? "Content-Panel" : "Content-Panel open"
        }
      >

        <AccountSettingComponent
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          context={context}
        />
      </div>
    </>
  );
};


AccountSetting.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default AccountSetting;
